import { render, staticRenderFns } from "./threeRight.vue?vue&type=template&id=3d55935a&"
import script from "./threeRight.vue?vue&type=script&lang=js&"
export * from "./threeRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports